export const SET_LOADING_DATA = '@productTechnical/SET_LOADING_DATA';
export const SET_LOADING_SELECTS = '@productTechnical/SET_LOADING_SELECTS';
export const SET_LOADING_SEND = '@productTechnical/SET_LOADING_SEND';
export const SET_LOADING_MODAL = '@productTechnical/SET_LOADING_MODAL';

export const GET_ALL_REQUEST = '@productTechnical/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@productTechnical/GET_ALL_SUCCESS';

export const GET_FILTER_SELECTS_REQUEST = '@productTechnical/GET_FILTER_SELECTS_REQUEST';
export const GET_FILTER_SELECTS_SUCCESS = '@productTechnical/GET_FILTER_SELECTS_SUCCESS';

export const GET_BY_ID_REQUEST = '@productTechnical/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@productTechnical/GET_BY_ID_SUCCESS';

export const SET_PAGE = '@productTechnical/SET_PAGE';
export const SET_ROWS_COUNT = '@productTechnical/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@productTechnical/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@productTechnical/SET_ORDER';
export const SET_ORDERBY = '@productTechnical/SET_ORDERBY';

export const SEARCH = '@productTechnical/SEARCH';

// FORM

export const SAVE_REQUEST = '@productTechnical/SAVE_REQUEST';
export const SAVE_SUCCESS = '@productTechnical/SAVE_SUCCESS';

export const GET_FILTER_PRODUCT_REQUEST = '@productTechnical/GET_FILTER_PRODUCT_REQUEST';
export const GET_FILTER_PRODUCT_SUCCESS = '@productTechnical/GET_FILTER_PRODUCT_SUCCESS';

export const DELETE_ITEMS = '@productTechnical/DELETE_ITEMS';
